import { ComponentStyleConfig } from '@chakra-ui/react';

export const Tooltip: ComponentStyleConfig = {
   baseStyle: {
      fontSize: 'md',
   },
   defaultProps: {
      openDelay: 50,
      shouldWrapChildren: true,
      closeOnMouseDown: true,
   },
};
